import styled from "styled-components";

import { colors, fontSize, fontStyle, space, borderRadius } from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";
import { IconButton } from "shared/components/IconButton/IconButton";

export const StyledTable = styled.div``;

export const StyledHeaderItem = styled.div`
  text-align: left;
  text-transform: uppercase;
  ${fontStyle.bold}
  ${fontSize.xxs}
  letter-spacing: 1px;
`;

interface styledRowProps {
  hasIcon?: boolean;
  hasDragAndDrop?: boolean;
}

export const StyledRow = styled.div<styledRowProps>`
  display: grid;
  grid-template-columns: ${({ hasIcon, hasDragAndDrop }) =>
    `${hasDragAndDrop ? "45px " : ""}${hasIcon ? "60px " : ""}1fr 25px`};
  grid-gap: ${space.xs};
  align-items: flex-start;

  margin: ${space.xs} 0;
`;

export const StyledCell = styled.div`
  height: 42px;
`;

export const StyledDragAndDropButton = styled.div`
  padding: ${space.s};

  background-color: ${colors.grey1};

  border: 1px solid ${colors.grey2};
  border-radius: ${borderRadius.s};

  display: flex;
  align-items: center;
  justify-content: center;

  ${hoverFocus.defaultHover(colors.grey1, colors.grey3)};
`;

export const StyledDeleteButton = styled(IconButton)`
  height: 100%;
`;
